<script setup lang="ts">
import {watch} from "vue";
import {authenticationService} from "@/container";
import HubspotService from "@/core/services/HubspotService";
import {useSystemStore} from "@/stores/system.store";
import {storeToRefs} from "pinia";

const {environment} = storeToRefs(useSystemStore());

/**
 * Identify the signed-in user to HubSpot, so the support inbox shows who is
 * writing and from which pharmacy. Waits for the environment, which can arrive
 * after this component mounts, e.g. when the app is reloaded on the home screen.
 */
watch(environment, async (access, _previousAccess, onCleanup) => {
    let cancelled = false;
    onCleanup(() => {
        cancelled = true;
    });

    const user = await authenticationService().user();

    if (cancelled) {
        return;
    }

    if (user?.email && access) {
        HubspotService.identify({
            email: user.email,
            firstname: user.first_name,
            lastname: user.last_name,
            company: access.entity?.name,
        });
    }
}, {immediate: true});
</script>

<template>
  <component
    :is="'script'"
    src="https://js.hs-scripts.com/19888609.js"
    async
    defer
  />
</template>
